import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { Province } from '../../../models/province.model';
import { CountryService } from '../../../services/country/country.service';
import { StateService } from '../../../services/state/state.service';
import { Country } from './../../../models/country.model';
import { ProvinceService } from './../../../services/province/province.service';


@Component({
  selector: 'kv-province-form',
  templateUrl: 'provinceForm.html',
  styleUrls: ['./provinceForm.component.css']
})

export class ProvinceFormComponent implements OnInit {
  @Output() provinceAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() provinceUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxProvince: Province;

  addEditForm: FormGroup;
  countries: Array<Country>;
  states:  { value: number, label: string }[];
  fields: any;
  isCountryPresent: boolean = false;

  show = {
    form:false
  }

  model = {
    country: null,
    state: null
  }
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    private srvCountry: CountryService,
    private srvState: StateService,
    private provinceService: ProvinceService
  ) {}

  ngOnInit(): void {

    this.states = [];
    this.countries = [];

    let FieldsProvince =  this.provinceService.getFields();
    let Countries = Observable.of(null);
    let States = Observable.of(null);

    if(this.dialogBoxProvince && this.dialogBoxProvince.country_id){
      let searchCountries = [
        {key: 'id',value: this.dialogBoxProvince.country_id.toString()},
        {key: 'flg_state',value: "0"}
      ];
      Countries = this.srvCountry.list(null,null,searchCountries);

      let searchStates = [
        {key: 'id',value: this.dialogBoxProvince.state_id.toString()},
        {key: 'flg_state',value: "0"}
      ];
      States = this.srvState.list(null,null,searchStates);
    }


    Observable.zip(
      FieldsProvince,
      Countries,
      States
    ).subscribe(([
      resFields,
      resCountries,
      resStates
    ]) => {
      this.fields = resFields;
      this.countries = [];

      if(resCountries && resCountries.data){
        this.countries = resCountries.data;
        this.model.country = this.countries[0];
        this.isCountryPresent = true;
      }

      this.states = [];
      if(resStates && resStates.data){
        this.states = resStates.data;
        this.model.state = this.states[0];
      }

      this.addEditForm = this.fb.group({
        'code': new FormControl(this.dialogBoxProvince.code),
        'name': new FormControl(this.dialogBoxProvince.name),
        'state_id': new FormControl(this.dialogBoxProvince.state_id),
        'country_id': new FormControl(this.dialogBoxProvince.country_id)
      });

      this.show.form = true;

    });

  }
 /*** Gestione autocomplete Countries */
  filterCountrySingle(event){
    if(event){
      let search = [
        {key: 'name',value: event.query},
        {key: 'flg_state',value: "0"}
      ];
      this.srvCountry.list(null,null,search).subscribe(res=>{
        this.countries = [];
        if(res && res.data){
          this.countries = res.data;
        }
      })
    }
  }
  onSelectCountry(event){
    this.addEditForm.get('country_id').setValue(event.id);
    this.model.state = null;
    this.addEditForm.get('state_id').setValue(null);
    let search = [
      {key: 'country_id',value: event.id.toString()},
      {key: 'flg_state',value: "0"}
    ];
    this.srvState.list(null,null,search).subscribe(res=>{
      this.states = [];
      if(res && res.data){
        this.states = res.data;
      }
    })
    this.isCountryPresent = true;
  }
  onClearCountry(){
    this.addEditForm.get('country_id').setValue(null);
    this.addEditForm.get('state_id').setValue(null);
    this.model.country = null;
    this.model.state = null;
    this.isCountryPresent = false;
  }
  /*** Gestione autocomplete States */
  filterStateSingle(event){
    if(event){
      let search = [
        {key: 'name',value: event.query},
        {key: 'country_id', value: this.model.country.id.toString()}
      ];
      this.srvState.list(null,null,search).subscribe(res=>{
        this.states = [];
        if(res && res.data){
          this.states = res.data;
        }
      })
    }
  }
  onSelectState(event){
    this.addEditForm.get('state_id').setValue(event.id);
  }
  onClearState(){
    this.addEditForm.get('state_id').setValue(null);
  }
  saveOrUpdate(dialogBox: any): void {

    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.dialogBoxProvince, this.addEditForm.value);
    if (newData.id == null) {
      this.provinceAdded.emit(newData);
    } else {
      this.provinceUpdated.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/province/provinceForm.component.ts